module.exports = __webpack_public_path__ + "img/cloudy-rain.697f734.svg";